export const SITE_URL = 'https://quoridorapp.ru';

export const DEFAULT_SEO = {
  title: 'Коридор',
  description: 'Мобильная игра Коридор (Quoridor)',
  image: `${SITE_URL}/icon-512.png`,
  locale: 'ru_RU',
} as const;

export const LEGAL_SEO: Record<string, { title: string; description: string }> = {
  privacy: {
    title: 'Политика конфиденциальности',
    description:
      'Коридор (quoridorapp.ru) обрабатывает данные, необходимые для игры и аккаунта: никнейм, email, рейтинг, история партий, настройки и технические токены сессии.',
  },
  terms: {
    title: 'Условия использования',
    description:
      'Используя Коридор, вы соглашаетесь играть честно, не злоупотреблять API и не мешать другим игрокам.',
  },
  support: {
    title: 'Поддержка',
    description: 'По вопросам аккаунта, багов и предложений:',
  },
};

const PRIVATE_ROUTE_PATTERNS = [
  '/auth',
  '/auth/apple/callback',
  '/game',
  '/result',
  '/profile',
  '/friends',
  '/friend/:id',
  '/rank',
  '/settings',
  '/tutorial',
  '/matchmaking',
  '/lobby',
  '/join/:code',
  '/invite/:id',
] as const;

export function isPrivateRoute(pathname: string): boolean {
  return PRIVATE_ROUTE_PATTERNS.some((pattern) => {
    const patternParts = pattern.split('/').filter(Boolean);
    const pathParts = pathname.split('/').filter(Boolean);
    if (patternParts.length !== pathParts.length) return false;
    return patternParts.every((part, i) => part.startsWith(':') || part === pathParts[i]);
  });
}

export function getLegalPage(pathname: string): string | null {
  const match = pathname.match(/^\/legal\/([^/]+)$/);
  return match?.[1] ?? null;
}
